import React from 'react';
import PropTypes from 'prop-types';

class GridTable extends React.Component {
  constructor(props) {
    super(props);
  }
  getName() {
    return 'GridTable';
  }
  render() {
    const {schema} = this.props;
    const children = React.Children.toArray(this.props.children);

    const headers = children
        .filter(child => (child.type.prototype.getName ? child.type.prototype.getName() == 'GridHeaders' : false))
        .map( child => React.cloneElement(child, {schema}));
    const rows =
      children
        .filter(child => (child.type.prototype.getName? child.type.prototype.getName() == 'GridRow' : false))
        .map( child => React.cloneElement(child, {schema}));
    return (
      <div>
        <table className={this.props.className}>
          {(()=>{
            if(headers.length > 0)
              return headers[0];
          })()}
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }
}

GridTable.propTypes = {
  schema : PropTypes.array.isRequired
}

export default GridTable;



// WEBPACK FOOTER //
// ./src/browser/components/ui/table/gridTable.js